var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modalPreviewForm","hide-footer":"","centered":"","size":"lg","title":_vm.form.name}},[(_vm.form && _vm.form.formElements)?_c('Preview',{attrs:{"form":_vm.form}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }